// src/services/adminRankBoardService.ts

import { apiClient } from "./apiClient";
import { RankBoardEntryDto, RankScoringConfigDto } from "../types/rankBoard.types";

const BASE_URL = "/api/admin/rookies";

/**
 * Get the full ranked rookie board.
 * The backend always computes fresh data, so the panel's refresh button
 * simply calls this again.
 */
export const getRookieBoard = async (): Promise<RankBoardEntryDto[]> => {
  return apiClient.get<RankBoardEntryDto[]>(BASE_URL);
};

/**
 * Get the full ranked authors board (AUTHOR + MODERATOR + ADMIN users) —
 * same scoring model and shape as the rookie board. Always computed fresh
 * by the backend.
 */
export const getAuthorBoard = async (): Promise<RankBoardEntryDto[]> => {
  return apiClient.get<RankBoardEntryDto[]>("/api/admin/authors");
};

/**
 * Get the scoring coefficients (powers the in-panel documentation block).
 */
export const getRankScoringConfig = async (): Promise<RankScoringConfigDto> => {
  return apiClient.get<RankScoringConfigDto>(`${BASE_URL}/scoring-config`);
};